import { ArrowUp } from "lucide-react";
import { Toon } from "@/components/Toon";

export default function Footer({ onNavigate }) {
  return (
    <footer
      data-testid="footer"
      className="border-t border-white/10 bg-panel/40"
    >
      <div className="mx-auto flex max-w-[90rem] flex-col gap-8 px-6 py-12 md:flex-row md:items-center md:justify-between md:px-12">
        <div className="flex max-w-xl items-center gap-5">
          <Toon testId="footer-toon" variant="wave" imgClass="w-40 md:w-48" className="shrink-0" />
          <div>
            <p className="font-serif text-lg text-fog">
              CallMe📲<span className="italic text-steel">Gerard</span>
            </p>
            <p
              data-testid="footer-legal"
              className="mt-3 text-xs leading-relaxed text-dim"
            >
              CallMe📲Gerard.com is a remote inbound/outbound call center marketing
              function of CRM, LLC. All rights reserved.
            </p>
          </div>
        </div>
        <div className="flex items-center gap-8">
          <span className="text-xs uppercase tracking-[0.25em] text-dim">
            © 2026
          </span>
          <button
            data-testid="back-to-top-button"
            onClick={() => onNavigate(0)}
            className="inline-flex items-center gap-2 rounded-full border border-white/15 px-5 py-2 text-xs uppercase tracking-[0.2em] text-ash transition-[background-color,border-color,color] duration-300 hover:border-navy hover:bg-navy hover:text-white"
          >
            <ArrowUp className="h-3.5 w-3.5" />
            Top
          </button>
        </div>
      </div>
    </footer>
  );
}
